import { create } from 'zustand';

interface EquipmentFilters {
  searchTerm?: string;
  site?: string;
  status?: 'available' | 'maintenance';
}

interface EquipmentState {
  selectedEquipment?: number;
  filters: EquipmentFilters;
  setSelectedEquipment: (id?: number) => void;
  setFilters: (filters: EquipmentFilters) => void;
}

export const useEquipmentStore = create<EquipmentState>()((set) => ({
  selectedEquipment: undefined,
  filters: {},
  setSelectedEquipment: (id?: number) => set(() => ({ selectedEquipment: id })),
  setFilters: (filters: EquipmentFilters) => set(() => ({ filters })),
})); 